"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.settings.title': 'Impostazioni Chat',
    'chat.settings.media_generation': 'Generazione Media',
    'chat.settings.image_model': 'Modello Immagine',
    'chat.settings.video_model': 'Modello Video',
    'chat.settings.voice.label': 'Voce',
    'chat.settings.chat_learning.label': 'Impara sull\'utente dalla conversazione chat',
    'chat.settings.chat_learning.description': 'Il sistema analizzerà le tue conversazioni di tanto in tanto e adatterà il suo stile di risposta al modo in cui interagisci con il sistema',
    'chat.settings.enable_ai_assistant.label': 'Abilita Assistente IA',
    'chat.settings.enable_ai_assistant.description': 'Abilita l\'Assistente IA per fornire suggerimenti intelligenti e aiuto durante le tue conversazioni',
    'chat.settings.enable_ai_assistant.disabled_tooltip': 'L\'Assistente IA non è disponibile con il tuo piano attuale. Perfavore aggiorna per accedere a questa funzione.',
    'chat.settings.save': 'Salva',
    'chat.settings.saved': 'Impostazioni salvate con successo',
    'chat.settings.ai_parameters': 'Parametri IA',
    'chat.settings.temperature.label': 'Temperatura',
    'chat.settings.temperature.description': 'Controlla la casualità nelle risposte dell\'IA. Valori più bassi rendono le risposte più focalizzate e deterministiche, valori più alti le rendono più creative e varie.',
    'chat.settings.temperature.min_label': 'Rigoroso',
    'chat.settings.temperature.max_label': 'Creativo',
    'chat.settings.assistance_setup': 'Configurazione Assistenza',
    'chat.settings.max_tokens.label': 'Lunghezza Risposta',
    'chat.settings.max_tokens.description': 'Controlla la lunghezza massima delle risposte IA. Predefinito usa le impostazioni del modello, altre opzioni limitano la lunghezza della risposta.',
    'chat.settings.max_tokens.default': 'Predefinito (Impostazione Modello)',
    'chat.settings.max_tokens.short': 'Breve',
    'chat.settings.max_tokens.medium': 'Medio',
    'chat.settings.max_tokens.long': 'Lungo',
    'chat.settings.extended_context.label': 'Contesto Esteso',
    'chat.settings.extended_context.description': 'Abilita la modalità contesto esteso per mantenere una memoria di conversazione più lunga e una migliore comprensione dei messaggi precedenti',
    'chat.settings.thinking.label': 'Abilita Pensiero',
    'chat.settings.thinking.description': 'Mostra il ragionamento dell\'AI e il processo di pensiero durante la generazione delle risposte',
};
